import styled from 'styled-components';

import { ptr } from '#styles.utils';

export const FormikContainer = styled.div`
  .user-form__submit {
    min-width: ${ptr(200)};
  }
`;
